/**
 * Club Checkout Integration
 * Zeigt visuellen Hinweis im Warenkorb für Club-Mitglieder
 * Der automatische Rabatt wird durch Shopify's automatische Rabatte angewendet
 */

class ClubCheckout {
  constructor() {
    this.init();
  }
  
  init() {
    // Mit Shopify Plus und automatischen Rabatten wird der Rabatt automatisch angewendet wenn:
    // 1. Kunde hat Tag 'club-member-active' oder 'club-member-cancelled'
    // 2. Produkt im Warenkorb hat Tag 'club-accessories' oder ist in einer Club-Kollektion
  }
  
  async shouldApplyClubDiscount() {
    // Diese Methode wird noch vom mini-cart verwendet um zu prüfen
    // ob die Info-Box angezeigt werden soll
    try {
      const isClubMember = window.revellClubMembership?.isClubMember || false;
      
      if (!isClubMember) {
        return false;
      }
      
      const response = await fetch('/cart.js');
      const cart = await response.json();
      
      const hasEligibleProducts = await this.hasClubDiscountEligibleProducts(cart.items);
      
      return hasEligibleProducts;
      
    } catch (error) {
      return false;
    }
  }
  
  async hasClubDiscountEligibleProducts(cartItems) {
    try {
      const clubTag = window.themeVariables?.settings?.clubAccessoriesTag || 'club-accessories';
      const clubCollections = this.getClubCollections();
      
      for (const item of cartItems) {
        // Check if product has the club tag
        if (item.tags && item.tags.includes(clubTag)) {
          return true;
        }
        
        // Check if product is in a club discount collection
        try {
          const productResponse = await fetch(`/products/${item.handle}.js`);
          const productData = await productResponse.json();
          
          // Check product tags with case-insensitive comparison
          if (productData.tags) {
            const hasTag = productData.tags.some(tag => 
              tag.toLowerCase().trim() === clubTag.toLowerCase().trim()
            );
            
            if (hasTag) {
              return true;
            }
          }
          
        } catch (err) {
          // Silently fail if product details can't be fetched
        }
      }
      
      return false;
    } catch (error) {
      return false;
    }
  }
  
  getClubCollections() {
    const collections = [];
    for (let i = 1; i <= 8; i++) {
      const collection = window.themeVariables?.settings?.[`clubDiscountCollection${i}`];
      if (collection) {
        collections.push(collection);
      }
    }
    return collections;
  }
}

// Initialize when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    window.ClubCheckout = new ClubCheckout();
  });
} else {
  window.ClubCheckout = new ClubCheckout();
}

// Export for use in other scripts
window.ClubCheckout = ClubCheckout;

